// extracted by mini-css-extract-plugin
export default {"container":"AdminConsole_container__pH1S5","myTab":"AdminConsole_myTab__NeguF","MuiTab-wrapper":"AdminConsole_MuiTab-wrapper__oCrRf","tabContent":"AdminConsole_tabContent__h6SAC"};